import { h, Fragment } from "preact";
import { APARTMENT_FORM_TYPE } from "../../ApartmentForm.types";
import OwnerStepBuy from "./components/ownerStepBuy/OwnerStepBuy";
import OwnerStepSell from "./components/ownerStepSell/OwnerStepSell";

export default function OwnerStep({ type, formContext, onNext }) {
  return (
    <Fragment>
      {type === APARTMENT_FORM_TYPE.BUY ? (
        <OwnerStepBuy
          formContext={formContext}
          onNext={onNext}
        />
      ) : (
        <OwnerStepSell
          formContext={formContext}
          onNext={onNext}
        />
      )}
    </Fragment>
  );
}
